import { render, staticRenderFns } from "./sapKucunPage.vue?vue&type=template&id=53f1ab34&scoped=true"
import script from "./sapKucunPage.vue?vue&type=script&lang=js"
export * from "./sapKucunPage.vue?vue&type=script&lang=js"
import style0 from "./sapKucunPage.vue?vue&type=style&index=0&id=53f1ab34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1ab34",
  null
  
)

export default component.exports